import React, { useCallback, useState } from "react"
import CommonTypo from "../../../components/CommonTypo"
import { Autocomplete, Box, TextField, Paper, Button } from "@mui/material"
import NewButton from "../../../components/NewButton"
import { makeStyles } from "@material-ui/core";
import _debounce from "lodash/debounce";
import palette from "../../../theme/palette";
import { pxToRem } from "../../../theme/typography";
import shape from "../../../theme/shape";
import { onboardingPlansService } from "../../../services/onboardingPlans";
import { baseEndpoints } from "../../../services/config";
import { FontAwesomeIconRender, ICON_SLECTIN_TABS } from "../../../components/IconSelectionPopOver";

const useStyles = makeStyles((theme) => ({
    selectionBox: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "42px",
        gap: "8px",
        borderRadius: "20px",
        border: "1px solid var(--color-border)",
        paddingTop: "8px",
        paddingRight: "24px",
        paddingBottom: "8px",
        paddingLeft: "24px",
        // "&:hover": {
        //     border: "1px solid var(--color-new-main)",
        // },
    },

}))
const getImageUrl = (imgUrl, name, iconType) => {
    if (iconType === ICON_SLECTIN_TABS.EMOJI) {
        return <span style={{
            height: "16px",
            width: "16px",
            fontSize: "16px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
        }}>{imgUrl}</span>
    }
    if (iconType === ICON_SLECTIN_TABS.ICON) {
        return <FontAwesomeIconRender selectedIcon={imgUrl} style={{
            height: "16px",
            width: "16px",
        }} />
    }
    return <img style={{ height: "16px", width: "16px" }} src={`${baseEndpoints.getImage}${imgUrl}`} alt={name} />
}
const Step4 = ({ setNextStep, setPreviousStep, setStatus, selectedPlans: propsSelectedPlans = [], setSelectedPlans, secondselectedPlans, setSecondSelectedPlans, setSelectedPlanOutcomes,
    setSelectedPlanInfluences,
    setSelectedPlanReflectives,
    isDarkMode = false
}) => {
    const classes = useStyles()

    return <>
        <Box display={"flex"} flexDirection={"column"} gap={"4px"} alignItems={"center"}>
            <CommonTypo size={32} fontWeight={700} color="var(--color-text-primary)" lineHeight={36} extraSx={{
                whiteSpace: "nowrap"
            }}>Prioritize your goals</CommonTypo>
            <CommonTypo size={16} fontWeight={400} color="var(--color-text-primary)" lineHeight={22} extraSx={{
                whiteSpace: "nowrap"
            }}>Select the most important goal for now</CommonTypo>
        </Box>
        <Box display={"flex"} alignItems={"center"} justifyContent={"center"} flexWrap={"wrap"} sx={{
            maxHeight: '38vh',
            width: "70%",
            overflowY: 'auto',
            gap: "12px"
        }}>
            {propsSelectedPlans.map(it => {
                let selectedPlans = [...(secondselectedPlans || [])]
                const found = selectedPlans.find(ite => ite.categoryId === it.categoryId)
                return <Box className={classes.selectionBox} sx={{

                    border: found ? "1px solid var(--color-new-main)" : "1px solid var(--color-border)",
                }} onClick={() => {
                    // if (found) {
                    //     selectedPlans = selectedPlans.filter(ite => ite.categoryId !== it.categoryId)
                    //     setSecondSelectedPlans(selectedPlans)
                    //     const foundAlreadySelected = secondselectedPlans.find(ite => ite.categoryId === it.categoryId)
                    //     if (foundAlreadySelected) {
                    //         // setSecondSelectedPlans([])
                    //         // setSelectedPlanOutcomes([])
                    //         // setSelectedPlanInfluences([])
                    //         // setSelectedPlanReflectives([])
                    //     }
                    // } else {
                    //     if (selectedPlans.length < 3) {
                    //         selectedPlans.push(it)
                    //         setSecondSelectedPlans(selectedPlans)
                    //     }
                    // }
                    if (secondselectedPlans[0] && secondselectedPlans[0].categoryId !== it.categoryId) {
                        setSelectedPlanOutcomes([])
                        setSelectedPlanInfluences([])
                        setSelectedPlanReflectives([])
                    }
                    setSecondSelectedPlans([it])
                }}>
                    {it.iconUrl && getImageUrl(it.iconUrl, it.name, it.iconType)}
                    <CommonTypo size={16} color={isDarkMode ? 'var(--color-text-primary)' : 'var(--color-text-secondary)'}>{it.name}</CommonTypo>
                </Box>
            })}
        </Box>
    </>
}

export default Step4